import React from 'react';
import { Typography } from 'antd';
import { t } from 'i18next';

const { Title, Text } = Typography;

interface CardTitleProps {
  icon: React.ReactNode;
  title: string;
  fallbackCount?: number;
}

const KPISensorCardTitle: React.FC<CardTitleProps> = ({ icon, title, fallbackCount }) => {
  return (
    <div className="card-title-container">
      {icon}
      <Title level={5} className="card-title">
        {title}
      </Title>
      {fallbackCount && fallbackCount > 0 && (
        <Text className="card-fallback-count">
          • {fallbackCount} {t('fallbacks')}
        </Text>
      )}
    </div>
  );
};

export default KPISensorCardTitle;
